import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import { Form } from '@core/objects/form';
import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";
import { FieldFactoryLocator } from '@core/custom-forms/factories/field-factory-locator';
import { FieldDataInterface } from '@core/custom-forms/models/settings/settings-custom-form-field-data.model';

import * as fromSettingsFormsState from '@app/store/state/settings/custom-forms/custom-forms.state';
import * as fromSettingsFormsActions from '@app/store/state/settings/custom-forms/custom-forms.actions';

@Injectable({
    providedIn: 'root'
})
export class SettingsCustomFormsService {

    constructor(private store: Store<fromSettingsFormsState.SettingsCustomForms>) {}

    selectStarting = (): Observable<any>  => this.store.select(fromSettingsFormsState.startingSelector);
    // fields
    // loadAvailableFields = () => this.store.dispatch( new fromSettingsFormsActions.LoadAvailableFields());

    selectAvailableFields = () => this.store.select(fromSettingsFormsState.settingsFormsAvailableFieldsSelector);

    // forms list
    loadForms = () => this.store.dispatch( new fromSettingsFormsActions.LoadForms());

    selectForms = () => this.store.select(fromSettingsFormsState.settingsFormsFormsSelector);

    // current form
    loadForm = (id: string) => this.store.dispatch( new fromSettingsFormsActions.LoadForm(id));


    // load fields
    loadFields = (id: string) => this.store.dispatch( new fromSettingsFormsActions.LoadFields(id));

    // selectFields = () => this.store.select(fromSettingsFormsState.settingsFormsFieldsSelector);

    // actions

    saveForm = (form: Form) => this.store.dispatch( new fromSettingsFormsActions.SaveForm(form));

    // saveFields = (fields: Field[]) => this.store.dispatch( new fromSettingsFormsActions.SaveFields(fields));

    // active / deactive
    activeForm = (id: string) => this.store.dispatch(new fromSettingsFormsActions.SetActiveForm(id, true));

    deactiveForm = (id: string) => this.store.dispatch(new fromSettingsFormsActions.SetActiveForm(id, false));
    
    selectError = (key: string): Observable<HttpErrorResponse> => this.store.select(fromSettingsFormsState.errorSelector(key));



}

@Injectable({
    providedIn: 'root'
})
export class SettingsCustomFormsEditorService {
    constructor(private store: Store<fromSettingsFormsState.SettingsCustomForms>,private fieldFactoryLocator: FieldFactoryLocator) {}

    selectEditing = () => this.store.select(fromSettingsFormsState.settingsFormsEditingSelector);
    selectEditingFields = () => this.store.select(fromSettingsFormsState.settingsFormsEditingFieldsSelector);
    selectEditingActiveFields = () => this.store.select(fromSettingsFormsState.settingsFormsEditingActiveFieldsSelector);
    
    selectEditingModified = () => this.store.select(fromSettingsFormsState.settingsFormsEditingModifiedSelector);
    selectEditingNextPosition = () => this.store.select(fromSettingsFormsState.settingsFormsEditingNextPositionSelector);
    
    selectAwLinkRelatedFields = (): Observable<SettingsCustomFormFieldData[]> => this.store.select(fromSettingsFormsState.awLinkRelatedFieldsSelectors);

    // sync
    setName = (name: string) => this.store.dispatch( new fromSettingsFormsActions.SetFormName(name));
    setDescription = (description: string) => this.store.dispatch( new fromSettingsFormsActions.SetFormDescription(description));

    addField = (type: string) => {
        this.selectEditingNextPosition().pipe(
            take(1) // only subscribe once for one change, important in order to not add infinite fields.
        ).subscribe((nextPosition: number) => {
            const newField = this.fieldFactoryLocator.get(type).createSettingsFormField(nextPosition);
            this.store.dispatch(new fromSettingsFormsActions.AddField(newField));
        });
    };

    setField = (field: SettingsCustomFormFieldData) =>  this.store.dispatch( new fromSettingsFormsActions.SetField(field));
    removeField = (field : SettingsCustomFormFieldData) => this.store.dispatch( new fromSettingsFormsActions.RemoveField(field));
    
    moveFiedlUp = (field: SettingsCustomFormFieldData) => this.store.dispatch( new fromSettingsFormsActions.MoveFieldUp(field));
    moveFiedlDown = (field: SettingsCustomFormFieldData) => this.store.dispatch( new fromSettingsFormsActions.MoveFieldDown(field));

    updateFieldPositions = (fields: SettingsCustomFormFieldData[]) => this.store.dispatch( new fromSettingsFormsActions.UpdateFieldPositions(fields));

    clear = () => this.store.dispatch( new fromSettingsFormsActions.ClearEditing());
    
}